import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';

export enum EUsersRoute {
  users = 'users',
  tenant = 'tenant',
  owner = 'owner',
}

TaRoutes.addRoute({
  key: EUsersRoute.users,
  url: 'users',
  children: [
    {
      key: EUsersRoute.tenant,
      url: 'tenant/:id',
    },
    {
      key: EUsersRoute.owner,
      url: 'owner/:id',
    },
  ],
});

export const usersRoutes: Routes = [
  {
    path: TaRoutes.getUrl([EUsersRoute.users, EUsersRoute.tenant]),
    title: 'app.pages.tenant.title',
    loadComponent: () => import('./pages/tenant/tenant').then((c) => c.PublicTenantPage),
  },
  {
    path: TaRoutes.getUrl([EUsersRoute.users, EUsersRoute.owner]),
    title: 'app.pages.owner.title',
    loadComponent: () => import('./pages/owner/owner').then((c) => c.PublicOwnerPage),
  },
];
